export default function Suspended() {
  return (
    <div className="min-h-screen grid place-items-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-zinc-900 rounded-md p-6 shadow">
        <h1 className="text-xl font-semibold mb-2">Account Suspended</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400">Please contact support.</p>
      </div>
    </div>
  );
}
